import { frontendURL } from '../../../../helper/URLHelper';
import SettingsWrapper from '../SettingsWrapper.vue';
import SicargRolesIndex from './Index.vue';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/sicarg-roles'),
      component: SettingsWrapper,
      children: [
        {
          path: '',
          name: 'sicarg_roles_index',
          component: SicargRolesIndex,
          meta: {
            permissions: ['administrator'],
          },
        },
      ],
    },
  ],
};
